module.exports = __webpack_public_path__ + "assets/images/logo-intro_8d79853f0641b4ef90aebfc5fd71d398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-intro.png
// module id = 146
// module chunks = 0